import { createContext } from 'react';

type ContextType = {
    agent?: {agent_code: string}
};

export const AgentContext = createContext<ContextType>({});